import { Component } from '@angular/core';
import { UsersTableComponent } from "../../components/tables/manage-account/users-table/users-table.component";

@Component({
  selector: 'app-user',
  imports: [UsersTableComponent],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent {

}
